module.exports = __webpack_public_path__ + "static/media/keyvisual_login_small.f5289d6c.jpg";